import { Container, Row, Col } from 'react-bootstrap';
import { ArrowDown, ShieldCheck, Clock, CheckCircle } from 'react-bootstrap-icons';

export function HeroSection({ onGetStarted }) {
  return (
    <section className="qmi-hero">
      <div className="qmi-hero-bg"></div>
      <Container className="position-relative">
        <Row className="align-items-center min-vh-100 py-5">
          <Col lg={7} className="text-center text-lg-start">
            <div className="qmi-hero-content">
              {/* Trust Badge */}
              <div className="qmi-hero-badge animate-fade-in">
                <ShieldCheck size={16} />
                <span>Free & Confidential Estimates</span>
              </div>

              {/* Main Headline */}
              <h1 className="qmi-hero-title racing-sans-one-regular">
                Know What Your
                <span className="qmi-hero-title-accent"> Injury </span>
                Is Worth
              </h1>

              {/* Subheadline */}
              <p className="qmi-hero-subtitle">
                Get an instant estimate for your personal injury claim in under 2 minutes.
                No lawyers calling, no pressure — just answers.
              </p>

              {/* CTA Button */}
              <button
                className="qmi-btn-accent qmi-btn-xl hover-lift"
                onClick={onGetStarted}
              >
                Get Started
                <ArrowDown size={20} className="ms-2 animate-bounce" />
              </button>

              {/* Stats */}
              <div className="qmi-hero-stats">
                <div className="qmi-hero-stat">
                  <div className="qmi-hero-stat-value">10,000+</div>
                  <div className="qmi-hero-stat-label">Estimates Generated</div>
                </div>
                <div className="qmi-hero-stat">
                  <Clock size={20} className="qmi-hero-stat-icon" />
                  <div>
                    <div className="qmi-hero-stat-value">2 Min</div>
                    <div className="qmi-hero-stat-label">Average Time</div>
                  </div>
                </div>
                <div className="qmi-hero-stat">
                  <CheckCircle size={20} className="qmi-hero-stat-icon" />
                  <div>
                    <div className="qmi-hero-stat-value">100%</div>
                    <div className="qmi-hero-stat-label">Free to Use</div>
                  </div>
                </div>
              </div>
            </div>
          </Col>

        </Row>
      </Container>

      {/* Scroll indicator */}
      <div className="qmi-hero-scroll" onClick={onGetStarted}>
        <div className="qmi-hero-scroll-mouse">
          <div className="qmi-hero-scroll-wheel"></div>
        </div>
        <span>Scroll to begin</span>
      </div>
    </section>
  );
}
